import { useCurrentUser } from 'hooks/useCurrentUser'
import { useQuery } from 'hooks/useQuery'

import { fetchMembershipRequestsByUserId } from 'utils/queries/membershipRequests'

import { PendingMembership } from 'types/pendingMemberships'

/**
 * Gets membership requests for current user.
 * @returns A PendingMembership, which is an array of requests.
 */
export const useMembershipRequests = () => {
  const { data: currentUser } = useCurrentUser()

  return useQuery<Array<PendingMembership> | null>(['membershipRequests', currentUser?.id], () =>
    fetchMembershipRequestsByUserId(currentUser?.id),
  )
}
